"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  ELearningBookSmartphone: ['e-learning-book-smartphone', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M16.5,13.98s.613-1.9,5.864-2.1a.812.812,0,0,1,.886.739v7.8a.808.808,0,0,1-.843.731c-5.285.187-5.907,2.1-5.907,2.1V13.98s-.613-1.9-5.864-2.1a.812.812,0,0,0-.886.739v7.8a.808.808,0,0,0,.843.731c5.285.187,5.907,2.1,5.907,2.1', 'M6.75,21.751H3.483A2.732,2.732,0,0,1,.75,19.019V3.484A2.733,2.733,0,0,1,3.483.751H9.75a3,3,0,0,1,3,3V9', 'M0.75 17.251L6.75 17.251']],
  ELearningBookLaptop: ['e-learning-book-laptop', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M20.25,5.251v9a1.5,1.5,0,0,1-1.5,1.5H5.25a1.5,1.5,0,0,1-1.5-1.5v-9', 'M21.748,23.251H2.252A1.5,1.5,0,0,1,.91,21.081L2.746,17.41a3,3,0,0,1,2.683-1.659H18.571a3,3,0,0,1,2.683,1.659l1.836,3.671A1.5,1.5,0,0,1,21.748,23.251Z', 'M10.5 20.251L13.5 20.251', 'M12,2.412s.477-1.5,4.561-1.66a.635.635,0,0,1,.689.585V7.511a.634.634,0,0,1-.656.58C12.484,8.238,12,9.751,12,9.751V2.412S11.523.907,7.439.752a.635.635,0,0,0-.689.585V7.511a.634.634,0,0,0,.656.58C11.516,8.238,12,9.751,12,9.751']],
  ELearningLaptop1: ['e-learning-laptop-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15.75 4.126L15.75 8.085 12.75 9.001 9.75 8.085 9.75 4.126', 'M18.75 3.001L12.75 0.751 6.75 3.001 12.75 5.251 18.75 3.001z', 'M6.75 3.001L6.75 6.001', 'M20.25,5.251v9a1.5,1.5,0,0,1-1.5,1.5H5.25a1.5,1.5,0,0,1-1.5-1.5v-9', 'M21.748,23.251H2.252A1.5,1.5,0,0,1,.91,21.08l1.836-3.67a3,3,0,0,1,2.683-1.659H18.571a3,3,0,0,1,2.683,1.659l1.836,3.67A1.5,1.5,0,0,1,21.748,23.251Z', 'M10.5 20.251L13.5 20.251']],
  ELearningLaptopMath: ['e-learning-laptop-math', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.25,15.751V5.251a1.5,1.5,0,0,1,1.5-1.5h16.5a1.5,1.5,0,0,1,1.5,1.5v10.5', 'M14.584,15.751a2.976,2.976,0,0,1-5.168,0H.75v1.5a3,3,0,0,0,3,3h16.5a3,3,0,0,0,3-3v-1.5Z', 'M6,8.251a1.5,1.5,0,0,1,1.5-1.5h0A1.5,1.5,0,0,1,9,8.251H9a2.139,2.139,0,0,1-.468,1.336L6,12.751H9', 'M15.75,6.751h.75a.75.75,0,0,1,.75.75v5.25', 'M15.75 12.751L18.75 12.751', 'M11.25 9.751L14.25 9.751', 'M12.75 8.251L12.75 11.251']],
  ELearningLaptop: ['e-learning-laptop', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.750 8.001 A2.250 2.250 0 1 0 14.250 8.001 A2.250 2.250 0 1 0 9.750 8.001 Z', 'M7.974 11.635L10.225 9.384', 'M5.250 12.501 A1.500 1.500 0 1 0 8.250 12.501 A1.500 1.500 0 1 0 5.250 12.501 Z', 'M16.026 11.635L13.775 9.384', 'M15.750 12.501 A1.500 1.500 0 1 0 18.750 12.501 A1.500 1.500 0 1 0 15.750 12.501 Z', 'M2.25,17V4.251a1.5,1.5,0,0,1,1.5-1.5h16.5a1.5,1.5,0,0,1,1.5,1.5V17', 'M14.584,17a2.976,2.976,0,0,1-5.168,0H.75v1.5a3,3,0,0,0,3,3h16.5a3,3,0,0,0,3-3V17Z']],
  ELearningSmartphone: ['e-learning-smartphone', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.75,13.5v6.268A2.732,2.732,0,0,1,10.017,22.5H3.483A2.732,2.732,0,0,1,.75,19.769V4.234A2.733,2.733,0,0,1,3.483,1.5H9', 'M0.75 16.501L12.75 16.501', 'M6.75 19.126L6.75 19.126', 'M7.125,19.5a.375.375,0,0,0-.375-.375', 'M6.75,19.876a.374.374,0,0,0,.375-.375', 'M6.375,19.5a.374.374,0,0,0,.375.375', 'M6.75,19.126a.375.375,0,0,0-.375.375', 'M20.25 5.585L20.25 9.77 16.5 10.853 12.75 9.77 12.75 5.585', 'M23.25 4.651L16.5 2.27 9.75 4.651 16.5 6.751 23.25 4.651z', 'M9.75 4.651L9.75 8.001']],
  ELearningMonitor: ['e-learning-monitor', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 0.751 L23.250 0.751 L23.250 18.751 L0.750 18.751 Z', 'M15.75 23.251L8.25 23.251 9 18.751 15 18.751 15.75 23.251z', 'M6 23.251L18 23.251', 'M18.75 7.501L18.75 9.751', 'M15.75,8.835v3.916a5.684,5.684,0,0,1-3.743,1.5,5.745,5.745,0,0,1-3.757-1.5V8.835', 'M5.25 7.501L12 10.501 18.75 7.501 12 4.501 5.25 7.501z']],
  ELearningShare: ['e-learning-share', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.750 3.736 A2.250 2.250 0 1 0 14.250 3.736 A2.250 2.250 0 1 0 9.750 3.736 Z', 'M7.974 7.369L10.225 5.118', 'M5.250 8.236 A1.500 1.500 0 1 0 8.250 8.236 A1.500 1.500 0 1 0 5.250 8.236 Z', 'M16.026 7.369L13.775 5.118', 'M15.750 8.236 A1.500 1.500 0 1 0 18.750 8.236 A1.500 1.500 0 1 0 15.750 8.236 Z', 'M3.75,22.5,1.736,19.984A4.5,4.5,0,0,1,.75,17.173V12a1.5,1.5,0,0,1,1.5-1.5h0A1.5,1.5,0,0,1,3.75,12v3.75', 'M8.25,22.5V19.365a4.5,4.5,0,0,0-.757-2.5L6.351,15.155a1.4,1.4,0,0,0-1.977-.445h0A1.4,1.4,0,0,0,3.9,16.5l1.352,2.25', 'M20.25,22.5l2.014-2.517a4.5,4.5,0,0,0,.986-2.811V12a1.5,1.5,0,0,0-1.5-1.5h0a1.5,1.5,0,0,0-1.5,1.5v3.75', 'M15.75,22.5V19.365a4.5,4.5,0,0,1,.757-2.5l1.142-1.712a1.4,1.4,0,0,1,1.977-.445h0A1.4,1.4,0,0,1,20.1,16.5l-1.352,2.25']],
  ELearningExchange: ['e-learning-exchange', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M14.813 11.048L14.813 14.798 12 15.736 9.188 14.798 9.188 11.048', 'M17.625 10.111L12 8.236 6.375 10.111 12 11.986 17.625 10.111z', 'M6.375 10.111L6.375 13.286', 'M20.986,12.485A9,9,0,0,0,5.636,5.622l-.53.53', 'M3.014,11.487a9,9,0,0,0,15.35,6.863l.53-.531', 'M15.712 17.819L18.894 17.819 18.894 21.001', 'M8.288 6.152L5.106 6.152 5.106 2.97']]
};
exports["default"] = _default;